(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOutboundReferralStatus', CrmOutboundReferralStatus);

    CrmOutboundReferralStatus.$inject = ['$resource'];

    function CrmOutboundReferralStatus ($resource) {
        var resourceUrl =  'api/crm-outbound-referral-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
